<div class="flex flex-col bg-gray-300 h-full">
  <div class="flex flex-col sm:grid-cols-8 md:grid">
    <div class="col-span-1 m-4 md:col-span-4 md:m-8">
      <a href="https://www.hfalliance.com/" target="_blank" rel="nofollow">
        <div
          class="text-[1.25rem] font-bold leading-[2.875rem] md:text-[1.5rem] lg:text-[1.875rem] 2xl:text-[2.25rem]"
        >
          About Us
        </div>
        <hr class="my-[1rem] w-[65px] border-[1px] border-black" />
      </a>
      <div class="pb-2 pt-2">
        <app-typography [component]="'p'" [variant]="'body'">
          CollegeRecon’s CollegeFinder provides valuable information about the
          top colleges and universities for military and veterans using the Post
          9/11 GI Bill, Tuition Assistance, or researching Yellow Ribbon
          Schools.
        </app-typography>
      </div>

      <div class="pb-2 pt-2">
        <app-typography [component]="'p'" [variant]="'body'">
          CollegeRecon is built exclusively for the military community,
          including the US Army, Marine Corps, Navy, Air Force, Coast Guard, and
          DoD. Veterans, active military, the National Guard, Reserves, military
          spouses, and dependents can search nearly 7,000 top campus and online
          schools to find their best fit among veteran-friendly and
          military-friendly online colleges and universities for their education
          needs.
        </app-typography>
      </div>
      <div class="pb-2 pt-2">
        <app-typography [component]="'p'" [variant]="'body'" class="pb-2 pt-2">
          Data shown in the CollegeRecon School Search tool is the most current
          data available from federally provided resources or the schools
          themselves.
        </app-typography>
      </div>
      <div class="pb-2 pt-2">
        <app-typography [component]="'p'" [variant]="'body'" class="pb-2 pt-2">
          All data is provided from the following sources: WEAMS, IPEDS, and the
          Department of Veterans Affairs website or colleges’ or universities’
          administrators or websites.
        </app-typography>
      </div>
    </div>

    <div class="m-4 md:col-span-2 md:m-8">
      <div
        class="text-[1.25rem] font-bold leading-[2.875rem] md:text-[1.5rem] lg:text-[1.875rem] 2xl:text-[2.25rem]"
      >
        Contact Us
      </div>
      <hr class="my-[1rem] w-[65px] border-[1px] border-black" />
      <span class="bg-gray-800"></span>
      <div class="pb-4 pt-2">
        <div class="flex items-center">
          <i class="pi pi-map-marker me-2"></i>
          <app-typography [gutterBottom]="false" variant="smallBody"
            >College Recon</app-typography
          >
        </div>
        <app-typography [gutterBottom]="false" variant="smallBody"
          >1101 N Market Street, 2<sup>nd</sup> Floor <br />Milwaukee, WI
          53202</app-typography
        >
      </div>
      <div class="flex items-center">
        <i class="pi pi-phone me-2"></i>
        <app-typography [gutterBottom]="false" variant="smallBody"
          >414-350-6638</app-typography
        >
      </div>
      <div class="flex items-center">
        <i class="pi pi-envelope me-2"></i>
        <app-typography [gutterBottom]="false" variant="smallBody"
          >Information&#64;Collegerecon.com</app-typography
        >
      </div>
      <div class="flex items-center">
        <i class="pi pi-globe me-2"></i>
        <app-typography [gutterBottom]="false" variant="smallBody"
          >https://collegerecon.com</app-typography
        >
      </div>
      <div class="flex items-center">
        <i class="pi pi-facebook me-2"></i>
        <app-typography [gutterBottom]="false" variant="smallBody"
          >CollegeRecon</app-typography
        >
      </div>
    </div>
  </div>
  <div>
    <div class="m-8 text-center text-sm">
      <app-typography [component]="'p'" [variant]="'tag'">
        * CollegeRecon is not affiliated with the Department of Defense or the
        Department of Veterans Affairs. GI Bill® is a registered trademark of
        the U.S. Department of Veterans Affairs (VA). More information about
        education benefits offered by the VA is available at the official U.S.
        government web site at www.benefits.va.gov/gibill
      </app-typography>
    </div>
  </div>
  <div class="text-center">
    <div>
      <app-typography [component]="'p'" [variant]="'tag'">
        CollegeRecon © Copyright {{ year }}. All Rights Reserved.
      </app-typography>
    </div>
  </div>
</div>
